module.exports = __webpack_public_path__ + "static/media/tracing4.33a6e08c.png";